import React from 'react'

import PropTypes from 'prop-types'

import UtilityHeader from '../../headers/UtilityHeader'

const BlogHero = ({ Content, heroIsH1, title }) => (
  <UtilityHeader className="mb-xl-9">
    <div className="container">
      {heroIsH1 ? <h1 className="mt-0 mt-md-6">{title}</h1> : <div className="h1 mt-0 mt-md-6">{title}</div>}
      <p className="text-white mb-0 mb-md-6">
        <Content />
      </p>
    </div>
  </UtilityHeader>
)

BlogHero.defaultProps = {
  Content: () => (
    <>
      The UMA healthcare blog{' '}
      <span className="d-none d-md-inline">
        covers information at the intersection of healthcare, education and employment. Our contributors are familiar
        with a wide range of subjects covering professional development, career advancement, healthcare
        industry-specific topics, and education.
      </span>
    </>
  ),
  heroIsH1: true,
  title: 'In Healthcare Today',
}

BlogHero.propTypes = {
  Content: PropTypes.elementType,
  heroIsH1: PropTypes.bool,
  title: PropTypes.string,
}

export default BlogHero
